import debounce from 'lodash/debounce';
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {window} from 'ssr-window';
import EnvironmentUtils from '@spothero/utils/environment';

export default class DirectionsCardPanelMap extends Component {
    static propTypes = {
        facility: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);

        const isBrowser = EnvironmentUtils.isBrowser();
        const {
            facility: {
                latitude,
                longitude,
                airport: {
                    details: {
                        latitude: destinationLatitude,
                        longitude: destinationLongitude
                    }
                }
            }
        } = props;

        this._iconSize = 32;
        this._gmaps = (isBrowser) ? window.google.maps : null;
        this._iconBasePath = `https://res.cloudinary.com/spothero/image/upload/c_fill,dpr_2.0,w_${this._iconSize}/v1513266229/google-assistant`;
        this._directionsService = (isBrowser) ? new this._gmaps.DirectionsService() : null;
        this._directionsDisplay = (isBrowser) ? new this._gmaps.DirectionsRenderer({
            polylineOptions: {
                strokeColor: '#0082ff',
                strokeOpacity: 1,
                strokeWeight: 2
            },
            suppressMarkers: true
        }) : null;
        this._spotLatLng = (isBrowser) ? new this._gmaps.LatLng(latitude, longitude) : null;
        this._destinationLatLng = (isBrowser) ? new this._gmaps.LatLng(destinationLatitude, destinationLongitude) : null;
        this._bounds = (isBrowser) ? new this._gmaps.LatLngBounds() : null;

        if (isBrowser) {
            this._bounds.extend(this._spotLatLng);
            this._bounds.extend(this._destinationLatLng);
        }
    }

    componentDidMount() {
        setTimeout(() => {
            const mapOptions = {
                zoom: 17,
                center: this._destinationLatLng,
                mapTypeId: this._gmaps.MapTypeId.ROADMAP
            };

            this._googleMap = new this._gmaps.Map(this._map, mapOptions);
            this._spotMarker = new this._gmaps.Marker({
                map: this._googleMap,
                position: this._spotLatLng,
                icon: {
                    url: `${this._iconBasePath}/icon-location.png`,
                    scaledSize: new this._gmaps.Size(this._iconSize, this._iconSize)
                }
            });
            this._airportMarker = new this._gmaps.Marker({
                map: this._googleMap,
                position: this._destinationLatLng,
                icon: {
                    url: `${this._iconBasePath}/icon-destination.png`,
                    scaledSize: new this._gmaps.Size(this._iconSize, this._iconSize)
                }
            });
            this._directionsDisplay.setMap(this._googleMap);

            window.addEventListener('resize', debounce(this._onWindowResize, 100));

            this._onWindowResize();
            this._getDirections();
        }, 100);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);
    }

    _onWindowResize = () => {
        this._googleMap.fitBounds(this._bounds);
    }

    _getDirections() {
        this._directionsService.route({
            origin: this._spotLatLng,
            destination: this._destinationLatLng,
            travelMode: 'DRIVING'
        }, (result, status) => {
            if (status === 'OK') {
                this._directionsDisplay.setDirections(result);
                this._onWindowResize();
            }
        });
    }

    render() {
        return (
            <div className="DirectionsCardPanelMap">
                <div ref={node => { this._map = node; }} />
            </div>
        );
    }
}
